import { create } from 'zustand'
import { produce } from 'immer'
import { LoginApiResponse } from "@/lib/interfaces"

interface Attributes {
    token: string
    loggedIn: boolean
    apiKey: string
    selectedAccount: {
        id: string
        is_retail: boolean
        role: string
        cod_enabled: boolean
        unfulfil_enabled: boolean
        selected_lsp_enabled: boolean
    }
    accountIds: string[]
    phoneNumber: string | undefined
    email: string | undefined
    curPage: string
    paytmTab: 'Home' | 'Orders' | 'Issues' | 'Wallet' | 'Help' | 'Wallet-U'
}


interface State extends Attributes {
    setLogin: (accountInfo: LoginApiResponse) => void
    checkLoginStatus: () => void
    clearAuth: () => void
    setPage: (page: 'Orders'|'Wallet'|'Reports'|'Issues'|'Manage' | 'Support' | 'Surge' | 'Slots' | 'Search Gig' | 'Gigs') => void
    setPaytmTab: (tab:  'Home' | 'Orders' | 'Issues' | 'Wallet' | 'Help' | 'Wallet-U') => void
}

const initialState: Attributes = {
    token: '',
    accountIds: [],
    email: '',
    apiKey: '',
    selectedAccount: {
        id: '',
        is_retail: false,
        role: '',
        cod_enabled: false,
        unfulfil_enabled: false,
        selected_lsp_enabled: false
    },
    phoneNumber: '',
    loggedIn: false,
    curPage: '',
    paytmTab: 'Home'

};

export const useStore = create<State>()((set) => ({
    ...initialState,
    setLogin: (loggedIn) => {
        localStorage.setItem('accountId', loggedIn.selected_account.id)
        localStorage.setItem('token', loggedIn.access_token)
        localStorage.setItem('role', loggedIn.selected_account.role)
        localStorage.setItem('email', loggedIn.mail_id || localStorage.getItem('email') || '')
        localStorage.setItem('apiKey', loggedIn.api_key)
        localStorage.setItem('phoneNumber', loggedIn.phone_number || localStorage.getItem('phoneNumber') || '')
        localStorage.setItem('codEnabled', loggedIn.selected_account.cod_enabled.toString())
        localStorage.setItem('unfulfilEnabled', loggedIn.selected_account.unfulfil_enabled.toString())
        localStorage.setItem('selectedLspEnabled', loggedIn.selected_account.selected_lsp_enabled.toString())
        localStorage.setItem('isRetail', loggedIn.selected_account.is_retail.toString())
        localStorage.setItem('accountIds', JSON.stringify(loggedIn.account_ids))

        set(produce((state: State) => {
            state.loggedIn = true
            state.accountIds = loggedIn.account_ids
            state.email = loggedIn.mail_id || state.email
            state.apiKey = loggedIn.api_key
            state.phoneNumber = loggedIn.phone_number || state.phoneNumber
            state.selectedAccount = {
                id: loggedIn.selected_account.id,
                is_retail: loggedIn.selected_account.is_retail,
                role: loggedIn.selected_account.role,
                cod_enabled: loggedIn.selected_account.cod_enabled,
                unfulfil_enabled: loggedIn.selected_account.unfulfil_enabled,
                selected_lsp_enabled: loggedIn.selected_account.selected_lsp_enabled
            }
            state.token = loggedIn.access_token
        }))
    },
    clearAuth: () => {
        localStorage.removeItem('accountId')
        localStorage.removeItem('role')
        localStorage.removeItem('email')
        localStorage.removeItem('apiKey')
        localStorage.removeItem('phoneNumber')
        localStorage.removeItem('codEnabled')
        localStorage.removeItem('unfulfilEnabled')
        localStorage.removeItem('selectedLspEnabled')
        localStorage.removeItem('isRetail')
        localStorage.removeItem('accountIds')
        localStorage.removeItem('token')

        set(produce((state: State) => {
            state.token = ''
            state.loggedIn = false
            state.accountIds = []
            state.email = ''
            state.apiKey = ''
            state.phoneNumber = ''
            state.selectedAccount = {
                id: '',
                is_retail: false,
                role: '',
                cod_enabled: false,
                unfulfil_enabled: false,
                selected_lsp_enabled: false
            }
        }))
    },
    checkLoginStatus: async () => {
        const apiKey = localStorage.getItem("apiKey")
        const token = localStorage.getItem("token")
        const accountId = localStorage.getItem("accountId")
        const email = localStorage.getItem("email")
        const role = localStorage.getItem("role")
        const phoneNumber = localStorage.getItem("phoneNumber")
        const codEnabled = localStorage.getItem("codEnabled")
        const unfulfilEnabled = localStorage.getItem("unfulfilEnabled")
        const selectedLspEnabled = localStorage.getItem("selectedLspEnabled")
        const isRetail = localStorage.getItem("isRetail")
        const accountIds = localStorage.getItem("accountIds")

        if (accountId && role && accountIds && token) {
            set(produce((state: State) => {
                state.token = token
                state.loggedIn =  true
                state.accountIds = JSON.parse(accountIds)
                state.email = email || undefined
                state.apiKey = apiKey || ''
                state.phoneNumber = phoneNumber || undefined
                state.selectedAccount = {
                    id: accountId,
                    is_retail: isRetail === 'true',
                    role: role,
                    cod_enabled: codEnabled === 'true',
                    unfulfil_enabled: unfulfilEnabled === 'true',
                    selected_lsp_enabled: selectedLspEnabled === 'true'
                }
            }))
        }
    },
    setPage: async (page) => {
        set(produce((state: State) => {
            state.curPage = page
        }))
    },
    setPaytmTab: async (tab) => {
        set(produce((state: State) => {
            state.paytmTab = tab
        }))
    }
}))
